// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{\n\t--primary: #003671;\n\t--primary-shade: #0A4F8C;\n}\n", "",{"version":3,"sources":["webpack://src/assets/css/variations.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,wBAAwB;AACzB","sourcesContent":[":root{\n\t--primary: #003671;\n\t--primary-shade: #0A4F8C;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
